// utils
const util = require("vis-util/esnext");
exports.util = util;
exports.DOMutil = require("./lib/DOMutil");

// data
const { DataSet, DataView, Queue } = require("vis-data/esnext");
exports.DataSet = DataSet;
exports.DataView = DataView;
exports.Queue = Queue;

// Graph3d
exports.Graph3d = require("./lib/graph3d/Graph3d");
exports.graph3d = {
  Camera: require("./lib/graph3d/Camera"),
  Filter: require("./lib/graph3d/Filter"),
  Point2d: require("./lib/graph3d/Point2d"),
  Point3d: require("./lib/graph3d/Point3d"),
  Slider: require("./lib/graph3d/Slider"),
  StepNumber: require("./lib/graph3d/StepNumber"),
};

// bundled external libraries
exports.Hammer = require("vis-util/esnext").Hammer;
exports.keycharm = require("keycharm");
